"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateNextAvailableQuantity = exports.convertItemQuantityToPC = exports.convertPriceToUom = exports.convertQuantityUOM = void 0;

var common_enums_1 = require("@ryerson/common.enums");

var bignumber_js_1 = require("bignumber.js");

var bMEASUREMENT_CONSTANTS = {
  bPOUNDS_PER_CWT: new bignumber_js_1.BigNumber(100),
  bINCHES_PER_FOOT: new bignumber_js_1.BigNumber(12),
  bSQUARE_INCHES_PER_SQUARE_FOOT: new bignumber_js_1.BigNumber(144)
};

var convertQuantityUOM = function convertQuantityUOM(item, toUom, noRound) {
  try {
    var pounds;
    var Qty_float = new bignumber_js_1.BigNumber(item.quantity);

    switch (item.uom) {
      case common_enums_1.UOM.LB:
        pounds = Qty_float;
        break;

      case common_enums_1.UOM.PC:
        pounds = Qty_float.multipliedBy(new bignumber_js_1.BigNumber(item.weightPerPiece));
        break;

      case common_enums_1.UOM.FT2:
        pounds = Qty_float.multipliedBy(new bignumber_js_1.BigNumber(item.weightPerSquareFoot));
        break;

      case common_enums_1.UOM.FT:
        pounds = Qty_float.multipliedBy(new bignumber_js_1.BigNumber(item.weightPerFoot));
        break;

      case common_enums_1.UOM.SQIN:
        pounds = Qty_float.multipliedBy(new bignumber_js_1.BigNumber(item.weightPerSquareFoot).dividedBy(bMEASUREMENT_CONSTANTS.bSQUARE_INCHES_PER_SQUARE_FOOT));
        break;

      case common_enums_1.UOM.IN:
        pounds = Qty_float.multipliedBy(new bignumber_js_1.BigNumber(item.weightPerFoot).dividedBy(bMEASUREMENT_CONSTANTS.bINCHES_PER_FOOT));
        break;

      case common_enums_1.UOM.CWT:
        pounds = Qty_float.multipliedBy(bMEASUREMENT_CONSTANTS.bPOUNDS_PER_CWT);
        break;

      default:
        pounds = (0, bignumber_js_1.BigNumber)(0);
    }

    var quantity;

    switch (toUom) {
      case common_enums_1.UOM.LB:
        quantity = pounds;
        break;

      case common_enums_1.UOM.PC:
        quantity = item.weightPerPiece !== 0 ? pounds.dividedBy(new bignumber_js_1.BigNumber(item.weightPerPiece)) : (0, bignumber_js_1.BigNumber)(0);
        break;

      case common_enums_1.UOM.FT2:
        quantity = item.weightPerSquareFoot !== 0 ? pounds.dividedBy(new bignumber_js_1.BigNumber(item.weightPerSquareFoot)) : (0, bignumber_js_1.BigNumber)(0);
        break;

      case common_enums_1.UOM.FT:
        quantity = item.weightPerFoot !== 0 ? pounds.dividedBy(new bignumber_js_1.BigNumber(item.weightPerFoot)) : (0, bignumber_js_1.BigNumber)(0);
        break;

      case common_enums_1.UOM.SQIN:
        {
          if (item.weightPerSquareFoot !== 0) {
            quantity = pounds.dividedBy(new bignumber_js_1.BigNumber(item.weightPerSquareFoot).dividedBy(bMEASUREMENT_CONSTANTS.bSQUARE_INCHES_PER_SQUARE_FOOT));
          } else {
            quantity = (0, bignumber_js_1.BigNumber)(0);
          }

          break;
        }

      case common_enums_1.UOM.IN:
        quantity = pounds.dividedBy(new bignumber_js_1.BigNumber(item.weightPerFoot).dividedBy(bMEASUREMENT_CONSTANTS.bINCHES_PER_FOOT));
        break;

      case common_enums_1.UOM.CWT:
        quantity = pounds.dividedBy(bMEASUREMENT_CONSTANTS.bPOUNDS_PER_CWT);
        break;

      default:
        quantity = new bignumber_js_1.BigNumber(0);
    }
    /** Truncate any decimals - UI only shows decimals in conversions
     * */


    return noRound ? quantity.toString() : quantity.integerValue().toString();
  } catch (_a) {
    return "";
  }
};

exports.convertQuantityUOM = convertQuantityUOM;

var convertPriceToUom = function convertPriceToUom(item, priceToConvert, uom, prevUoM) {
  try {
    var pricePerPound; // aka "I2P Price"

    var price_float = new bignumber_js_1.BigNumber(priceToConvert);

    switch (prevUoM ? prevUoM : item.pricingUom) {
      case common_enums_1.UOM.LB:
        pricePerPound = price_float;
        break;

      case common_enums_1.UOM.PC:
        pricePerPound = price_float.dividedBy(item.weightPerPiece);
        break;

      case common_enums_1.UOM.FT2:
        pricePerPound = price_float.dividedBy(item.weightPerSquareFoot);
        break;

      case common_enums_1.UOM.FT:
        pricePerPound = price_float.dividedBy(item.weightPerFoot);
        break;

      case common_enums_1.UOM.SQIN:
        pricePerPound = price_float.dividedBy(new bignumber_js_1.BigNumber(item.weightPerSquareFoot).dividedBy(bMEASUREMENT_CONSTANTS.bSQUARE_INCHES_PER_SQUARE_FOOT));
        break;

      case common_enums_1.UOM.IN:
        pricePerPound = price_float.dividedBy(new bignumber_js_1.BigNumber(item.weightPerFoot).dividedBy(bMEASUREMENT_CONSTANTS.bINCHES_PER_FOOT));
        break;

      case common_enums_1.UOM.CWT:
        pricePerPound = price_float.dividedBy(bMEASUREMENT_CONSTANTS.bPOUNDS_PER_CWT);
        break;

      default:
        pricePerPound = new bignumber_js_1.BigNumber(0);
    }

    var price;

    switch (uom) {
      case common_enums_1.UOM.LB:
        price = pricePerPound;
        break;

      case common_enums_1.UOM.PC:
        price = pricePerPound.multipliedBy(item.weightPerPiece);
        break;

      case common_enums_1.UOM.FT2:
        price = pricePerPound.multipliedBy(item.weightPerSquareFoot);
        break;

      case common_enums_1.UOM.FT:
        price = pricePerPound.multipliedBy(item.weightPerFoot);
        break;

      case common_enums_1.UOM.SQIN:
        price = pricePerPound.multipliedBy(new bignumber_js_1.BigNumber(item.weightPerSquareFoot).dividedBy(bMEASUREMENT_CONSTANTS.bSQUARE_INCHES_PER_SQUARE_FOOT));
        break;

      case common_enums_1.UOM.IN:
        price = pricePerPound.multipliedBy(new bignumber_js_1.BigNumber(item.weightPerFoot).dividedBy(bMEASUREMENT_CONSTANTS.bINCHES_PER_FOOT));
        break;

      case common_enums_1.UOM.CWT:
        price = pricePerPound.multipliedBy(bMEASUREMENT_CONSTANTS.bPOUNDS_PER_CWT);
        break;

      default:
        price = new bignumber_js_1.BigNumber(0);
    }

    return price.decimalPlaces(2).toString();
  } catch (_a) {
    return "0.00";
  }
};

exports.convertPriceToUom = convertPriceToUom;

var convertItemQuantityToPC = function convertItemQuantityToPC(item) {
  var shouldRound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var itemCount, lengthOfMaterial, calculatedItemCount;
  var materialLength = item.materialLengthNominal || item.materialLengthMin;

  try {
    var weightPerPiece = new bignumber_js_1.BigNumber(item.weightPerPiece);
    var bQty = new bignumber_js_1.BigNumber(item.quantity);

    switch (item.uom) {
      case common_enums_1.UOM.LB:
        calculatedItemCount = bQty.dividedBy(weightPerPiece).integerValue(bignumber_js_1.BigNumber.ROUND_DOWN);

        if (bQty.isLessThan(item.weightPerPiece)) {
          itemCount = (0, bignumber_js_1.BigNumber)(1);
          break;
        }

        if (calculatedItemCount.multipliedBy(item.weightPerPiece).integerValue().isLessThan(bQty)) {
          itemCount = calculatedItemCount.plus(new bignumber_js_1.BigNumber(1));
          break;
        }

        itemCount = calculatedItemCount;
        break;

      case common_enums_1.UOM.CWT:
        itemCount = bQty.multipliedBy(bMEASUREMENT_CONSTANTS.bPOUNDS_PER_CWT).dividedBy(weightPerPiece);
        break;

      case common_enums_1.UOM.EA:
      case common_enums_1.UOM.PC:
        itemCount = bQty;
        break;

      case common_enums_1.UOM.FT:
        itemCount = bQty.multipliedBy(item.weightPerFoot).dividedBy(weightPerPiece);
        break;

      case common_enums_1.UOM.FT2:
        if (materialLength === 0 || item.materialWidth === 0) {
          return item.quantity;
        }

        lengthOfMaterial = bQty.multipliedBy(bMEASUREMENT_CONSTANTS.bSQUARE_INCHES_PER_SQUARE_FOOT).dividedBy(item.materialWidth);
        itemCount = lengthOfMaterial.dividedBy(materialLength);
        break;

      case common_enums_1.UOM.IN:
        if (materialLength === 0) {
          return item.quantity;
        }

        itemCount = materialLength ? bQty.dividedBy(materialLength) : bQty;
        break;

      case common_enums_1.UOM.SQIN:
        if (materialLength === 0 || item.materialWidth === 0) {
          return item.quantity;
        }

        lengthOfMaterial = bQty.dividedBy(item.materialWidth);
        itemCount = lengthOfMaterial.dividedBy(materialLength);
        break;

      default:
        itemCount = new bignumber_js_1.BigNumber(0);
    }

    if (shouldRound) {
      itemCount = itemCount.integerValue(bignumber_js_1.BigNumber.ROUND_DOWN);
    }

    return itemCount.toString();
  } catch (error) {
    console.error(error);
    return "0";
  }
};

exports.convertItemQuantityToPC = convertItemQuantityToPC;

var calculateNextAvailableQuantity = function calculateNextAvailableQuantity(item) {
  var quantity = item.quantity,
      uom = item.uom,
      weightPerPiece = item.weightPerPiece,
      weightPerFoot = item.weightPerFoot,
      weightPerSquareFoot = item.weightPerSquareFoot;
  var qty = Number(quantity);

  if (!uom || uom === common_enums_1.UOM.LB && (weightPerPiece <= 0 || qty <= 0) || uom === common_enums_1.UOM.CWT && (weightPerPiece <= 0 || qty <= 0) || uom === common_enums_1.UOM.PC && qty <= 0 || uom === common_enums_1.UOM.FT && (weightPerPiece <= 0 || weightPerFoot <= 0 || qty <= 0) || // TODO tb dbl checked
  uom === common_enums_1.UOM.IN && (weightPerPiece <= 0 || weightPerFoot <= 0 || qty <= 0) || uom === common_enums_1.UOM.FT2 && (weightPerPiece <= 0 || weightPerSquareFoot <= 0 || qty <= 0) || uom === common_enums_1.UOM.SQIN && (weightPerPiece <= 0 || weightPerSquareFoot <= 0 || qty <= 0)) {
    return qty.toString();
  }

  var bWeightPerPiece = new bignumber_js_1.BigNumber(weightPerPiece);
  var bWeightPerFoot = new bignumber_js_1.BigNumber(weightPerFoot);
  var bWeightPerSquareFoot = new bignumber_js_1.BigNumber(weightPerSquareFoot);
  var bQty = new bignumber_js_1.BigNumber(qty);

  switch (uom) {
    case common_enums_1.UOM.PC:
      return bQty.toString();

    case common_enums_1.UOM.LB:
      return bQty.dividedBy(bWeightPerPiece).integerValue(bignumber_js_1.BigNumber.ROUND_UP).multipliedBy(bWeightPerPiece).integerValue(bignumber_js_1.BigNumber.ROUND_DOWN).toString();

    case common_enums_1.UOM.CWT:
      {
        return bQty.dividedBy(bWeightPerPiece.dividedBy(100)).integerValue(bignumber_js_1.BigNumber.ROUND_UP).multipliedBy(bWeightPerPiece.dividedBy(100)).integerValue(bignumber_js_1.BigNumber.ROUND_DOWN).toString();
      }

    case common_enums_1.UOM.FT:
      {
        var div = bWeightPerPiece.dividedBy(bWeightPerFoot);
        var rv = bQty.dividedBy(div).integerValue(bignumber_js_1.BigNumber.ROUND_UP).multipliedBy(div).integerValue(bignumber_js_1.BigNumber.ROUND_DOWN).toString();
        return rv;
      }

    case common_enums_1.UOM.IN:
      {
        var bInchesPerPiece = bWeightPerPiece.dividedBy(bWeightPerFoot).multipliedBy(12);
        var bUnits_IN = bQty.dividedBy(bInchesPerPiece);
        return bUnits_IN.integerValue(bignumber_js_1.BigNumber.ROUND_UP).multipliedBy(bInchesPerPiece).integerValue(bignumber_js_1.BigNumber.ROUND_DOWN).toString();
      }

    case common_enums_1.UOM.FT2:
      {
        var _div = bWeightPerPiece.dividedBy(bWeightPerSquareFoot);

        return bQty.dividedBy(_div).integerValue(bignumber_js_1.BigNumber.ROUND_UP).multipliedBy(_div).integerValue(bignumber_js_1.BigNumber.ROUND_DOWN).toString();
      }

    case common_enums_1.UOM.SQIN:
      {
        var divPerSquareInch = bWeightPerPiece.div(bWeightPerSquareFoot).multipliedBy(144);
        return bQty.dividedBy(divPerSquareInch).integerValue(bignumber_js_1.BigNumber.ROUND_UP).multipliedBy(divPerSquareInch).integerValue(bignumber_js_1.BigNumber.ROUND_DOWN).toString();
      }

    default:
      return qty.toString();
  }
};

exports.calculateNextAvailableQuantity = calculateNextAvailableQuantity;